<template>
<div class="page page_artDetail">
    <div class="trandsman" >
        <div class="info">
            <img v-if="info" :src="info.thumb ? ($publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" alt="" class="logo" />
            <span class="name" v-if="info.nickname">{{info.nickname}}</span>
        </div>
        <div class="action">
            <div class="guanzhu" @click="attentionClickFun">{{info.is_attention==1?'已关注':'关注'}}</div>
            <!-- <img :src="publicPath+'statics/images/tuji/share.png'" alt="" class="share" /> -->
        </div>
    </div>
    <!-- 资讯 -->
    <div class="yuekan_con" style="padding-top:2rem">
        <!-- 头条 -->
        <div class="type" v-if="headLine && headLine.length > 0">
            <div class="yuekan" >
                <ul class="type_head_list clearfix">
                    <van-list v-model="loading_history" :finished="finished_history" :immediate-check="false" @load="getHistoryList" >
                        <li class="head_item" v-for="(item,index) in headLine" :key="index" @click="toHeadDetail(item)">
                            <van-image v-if="item.thumb" :src="item.thumb? ($publicData.withHttpStart(item.thumb) ? item.thumb : imageUrl+item.thumb) :defaultTouxiang" fit="cover" :show-error="false" :show-loading="false" class="head_tu"  />
                            <div v-else-if="item.images" class="tu_back">
                                <van-image v-for="(thumb,index) in item.images.split(',')" :key="index" :src="thumb? ( $publicData.withHttpStart(thumb) ? thumb : imageUrl+thumb) :defaultTouxiang" fit="cover" :show-error="false" :show-loading="false" class="head_tu_2"  />
                            </div>
                            <div class="head_title" >
                                {{ item.title }}
                            </div>
                            <div class="head_desc" >
                                {{ item.describe }}
                            </div>
                            <div class="head_time" >
                                {{ item.created_at }}
                            </div>
                            <div class="head_sep" v-if="index!=headLine.length-1">
                                
                            </div>
                        </li>
                    </van-list>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            type: this.$route.query.type,
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            token: null,
            tradesmanId: this.$route.query.tradesmanId,
            headLine: [],
            imageUrl: this.$publicData.uploadImage,
            pages: {
                page: 1,
                size: 10
            },
            loading_history: true,
            finished_history: false,
			shareConfig: null, // 分享的相关配置
        };
    },
    created: function () {
        // if (this.type == 'b') {
        //     this.active = 'b'
        // }
        console.log('this.active', this.active)
        var that = this
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data': {
                    'naviTitle': '匠人头条',
                    levitate: true,
                    showStatusBar: true,
                    // 'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                }
                this.getData()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            }) 
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
		}
		
    },
    mounted: function () {
        console.log('mounted')

    },
    activated: function () {
        console.log('activated')
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            
        } else {
            this.isClient = false
            // 获取列表
            if (this.tradesmanId != this.$route.query.tradesmanId) {
                this.token = this.$store.getters.token
                this.tradesmanId = this.$route.query.tradesmanId
                this.pages = {
                    page: 1,
                    size: 10
                },
                this.headLine = []
                this.finished_history = false
                this.getData();
                this.getHistoryList()
            }
            
		}
    },
    methods: {
        getData() {
            this.getDetail()
            this.getHistoryList()
        },
        getDetail() {
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId
            }
            this.$api.tradesman.detail(param).then(res => {
                if (res.code == 200) {
                    var info = res.result
					this.info = info
					this.register_status = res.result.register_status
					// 未入驻,先判断用户是否为匠人,非匠人方可让他去入驻
					if(this.register_status != 1){
						this.getUserInfo()
					}
                    // 调微信分享参数
					this.getShareData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getHistoryList() {
            var that = this
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                page: this.pages.page,
			    size: this.pages.size
            }
            this.$api.tradesman.history(param).then(res => {
                if (res.code == 200) {
                    var list = res.result.headline
                    if (that.pages.page == 1) {
                        that.headLine = []
                    }
                    if (list && list.length > 0) {
						for (var i in list) {
							this.headLine.push(list[i])
						}
						this.pages.page++
						this.loading_history = false
                        this.finished_history = true
					} else {
						this.finished_history = true
					}
                } else {
                    this.$toast(res.message)
                }
            })
        },
        
		// 关注匠人对app和h5进行判断
		attentionClickFun(){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionClick();
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionClick();
			}
		},
		// 关注匠人
        attentionClick() {
            var type = 1
            if (this.info.is_attention == 1) {
                type = 2
            }
            var params = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                type: type
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    if (this.info.is_attention == 1) {
                        this.$toast('取消关注成功')
                    } else {
                        this.$toast('关注成功')
                    }
                    this.getDetail()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        toHeadDetail(item) {
            this.$router.push({
				path: '/toutiao/detail',
				query: {
					headline_id: item.headline_id
				}
			})
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.info.describe ? that.info.describe : '', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.info.thumb ? (that.$publicData.withHttpStart(that.info.thumb) ? that.info.thumb : that.imageUrl+that.info.thumb) : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		},
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
